<template>
  <v-list subheader>
    <v-list-group v-for="filter of configuredFilters" :key="filter.name" v-model="filter.active" append-icon="fas fa-chevron-down">
      <template v-slot:activator>
        <v-list-item-title v-text="filter.name"/>
      </template>

      <v-list-item v-for="type in filter.types" :key="type.name" @click="toggleFilter(filter.name, type.name)" class="pl-2">
        <v-list-item-content class="pt-0 pb-0">
          <div @click="toggleFilter(filter.name, type.name)" v-if="type.type === 'select'" class="pl-3">
            <v-switch v-model="type.selected" inset :label="type.name"/>
          </div>
         <v-container v-else-if="type.type === 'date'" fluid :key="type.name">
            <v-text-field  type="date" v-model="type.value" :name="type.name" :label="type.name" @input="toggleFilter(filter.name, type.name)"/>
          </v-container>
          <v-container v-else fluid :key="type.name">
            <v-text-field v-model="type.value" :name="type.name" :label="type.name" @input="toggleFilter(filter.name, type.name)"/>
          </v-container>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>

<script>
export default {
  name: 'GenericFilterer',
  props: {
    filters: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    baseQuery: {
      type: String,
      required: false,
    },
  },
  data: () => ({
    configuredFilters: [],
    configuredData: [],
    originalData: [],
    appliedFilters: [],
    syncedInitialData: false,
  }),
  computed: {
    abledToSearch() {
      return this.$store.state.abledToSearch;
    },
  },
  methods: {
    toggleFilter(filterName, orderName) {
      this.configuredFilters = this.configuredFilters.filter((filter) => {
        if (filter.name === filterName) {
          filter.types = filter.types.filter((type) => {
            if (type.name === orderName && type.type !== 'input') {
              type.selected = !type.selected;
            } else if (type.name === orderName && type.type == 'input') {
              type.selected = type.value ? true : false;
            }
            return type;
          });
        }
        return filter;
      });
    },
    applyQueryStrings() {
      let finalQuery = '';
      const filtersPerType = {};

      this.appliedFilters.forEach((filter) => {
        if (filtersPerType[filter.parent]) {
          filtersPerType[filter.parent] = [...filtersPerType[filter.parent], filter];
        } else {
          filtersPerType[filter.parent] = [filter];
        }
      });

      for (const filterKey of Object.keys(filtersPerType)) {
        const types = filtersPerType[filterKey];
        const values = types.filter(type => type.value).map(type => type.quotes !== false ? `'${type.value}'` : type.value) || [];

        if (values.length) {
          finalQuery += ` and ${filterKey} in (`;
          finalQuery += `${values})`;
        }
      }
      return finalQuery;
    },
    applyFilters() {

      this.appliedFilters = [];
      this.configuredFilters.forEach(filter => {
        const selectedTypes = filter.types.filter(type => type.selected);
        this.appliedFilters = [...this.appliedFilters, ...selectedTypes];
      });

      const finalQuery = this.applyQueryStrings();
      this.$store.commit('setQuery', finalQuery);

      if (!finalQuery) {
        this.$emit('filtersRemoved');
        return;
      }

      this.$emit('queryUpdate', finalQuery);
    },
    configureFiltersData() {

      this.configuredFilters = this.filters.map((filter) => {
        filter.types = filter.types.map((order) => ({ ...order, selected: false, parent: filter.key || filter.name }));
        filter.active = false;
        return filter;
      });
      this.configuredData = this.data;
      this.originalData = this.data;
      this.syncedInitialData = true;
    },
    clearFilters(){
      this.appliedFilters = [];
      this.configureFiltersData(this.filters);

      // this.configuredFilters.forEach( (filter) => {
      //   filter.active = false;
      // });

    }
  },
  created() {
    this.configureFiltersData();
  },
  watch: {
    '$store.state.abledToSearch'(newValue) {
      if (newValue) {
        this.applyFilters();
      }
    },
    data(newData) {
      if (!this.syncedInitialData) {
        this.configuredData = this.data;
        this.originalData = this.data;
        this.syncedInitialData = true;
      }
    },
  },
};
</script>
